import * as _ from 'lodash';
import { getDefectOptionsArray } from 'common/constants';
import { chartLinkQuery } from 'home/Activity/helpers/overallAlarmActivity';
import { getAccountMenuItems as getAccountMenuItemsWithT } from './constants/routes.constants';

export const isUnsavedAnalystSummaryExists = (localSummary, reduxSummary) => {
  if (localSummary.analyst_id) {
    // Use current i18n language for defect labels.
    let suspectedDefect = getDefectOptionsArray().filter(option => option.id === reduxSummary.suspected_defect);
    if (suspectedDefect.length > 0) suspectedDefect = suspectedDefect[0].name;
    return !(
      _.isEqual(localSummary.suspected_defect, suspectedDefect) &&
      _.isEqual(localSummary.description, reduxSummary.description)
    );
  }
  return !!(localSummary.condition || localSummary.suspected_defect || localSummary.description);
};

export const getFlattenedAccountMenuRoutes = (t, excludeRouteKeys = []) => {
  const isOldSignature = Array.isArray(t);
  const translate = isOldSignature ? undefined : t;
  const resolvedExcludeRouteKeys = isOldSignature ? t : excludeRouteKeys;
  const menuItems = getAccountMenuItemsWithT(translate);
  return _.flatMap(menuItems, ({ items }) =>
    items.filter(item => !resolvedExcludeRouteKeys.includes(item.key))
  );
};

export const getAccountMenuItems = (t, excludeRouteKeys = [], excludeGroupKeys = []) => {
  const isOldSignature = Array.isArray(t);
  const translate = isOldSignature ? undefined : t;
  const resolvedExcludeRouteKeys = isOldSignature ? t : excludeRouteKeys;
  const resolvedExcludeGroupKeys = isOldSignature ? excludeRouteKeys : excludeGroupKeys;
  const menuItems = getAccountMenuItemsWithT(translate)
    .filter(item => !resolvedExcludeGroupKeys.includes(item.key));
  return _.flatMap(menuItems, menuItem => [
    {
      key: menuItem.key,
      groupName: menuItem.displayName
    },
    ...menuItem.items.filter(item => !resolvedExcludeRouteKeys.includes(item.key))
  ]);
};

export const getChartSearchParams = (activity) => {
  let params = `?tag_id=${activity.tag_id}&timestamp=${activity.timestamp}`;
  if (activity.threshold_type) params = `${params}&threshold_type=${activity.threshold_type}`;
  if (activity.measurement_type) params = `${params}&measurement_type=${activity.measurement_type}`;
  params = `${params}${chartLinkQuery(activity)}`;
  return params;
};